<template>
<!-- Usage: <employee-details-card :employed="true" /> -->
    <div class="employee">
        <div class="employee-img">
            <input type="checkbox" class="checkbox">
            <div class="imgDetails">
                <img src="@/assets/user.svg" class="userImg">
                <div v-if="employed">
                    <p class="empId"> {{empId}} </p>
                    <div>
                        <span class="empName">{{empName}}</span><br>
                        <div class="empDetails"> {{empDetails}} <br> {{empDept}} </div>
                    </div>
                </div>
                <div v-else>
                    <br>
                    <div class="link-actions">
                        <img src="@/assets/linkedin.svg">
                        <img src="@/assets/facebook.svg">
                        <img src="@/assets/skype.svg">
                    </div>
                    <div v-if="onboarding">
                        <div class="progress-bar">
                            <div class="progress" ref="getProgress"></div>
                        </div>
                        <span class="show-progress"> {{ width }}% Completed </span>
                    </div>
                    <div v-else>
                        <div>
                            <button class="status-button"><i>{{joiningStatus}}</i></button>
                        </div>
                        <div class="joining-time">
                            <span> {{joiningTime}} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="employee-details">
            <div class="action-container">
                <div v-show="showActionMenu" class="action-menu">
                    <div class="edit" @click="edit" :class="{'selected':actionTypeVar==='edited'}"> Edit</div>
                    <div class="edit" @click="view" :class="{'selected':actionTypeVar==='view'}"> View in org chart</div>
                    <div class="edit" @click="holdSalary" :class="{'selected':actionTypeVar==='holdSalary'}"> Hold Salary</div>
                    <div class="edit" @click="assignManager" :class="{'selected':actionTypeVar==='assignManager'}"> Assign Manager</div>
                    <div class="edit" @click="assignRole" :class="{'selected':actionTypeVar==='assignRole'}"> Assign Role </div>
                    <div class="edit" @click="deleteEmp" :class="{'selected':actionTypeVar==='deleteEmp'}"> Delete</div>
                </div>
                <div @click="dropdown()"> <img src="@/assets/group-2.png" ></div>
            </div>

            <div class="details">
                <div> <img src="@/assets/phone-call.svg">{{empPhone}}</div>
                <div> <img src="@/assets/mail.svg">{{empMail}}</div>
                <div> <img src="@/assets/placeholder.svg">{{empAddress}}</div> <br>
                <div> Reports to <br> {{reportsTo}} </div> <br>
                <div v-if="employed">
                    <div> Status <br> {{empStatus}} </div> <br/>
                    <div class="link-actions">
                        <img src="@/assets/whatsapp.svg">
                        <img src="@/assets/linkedin.svg">
                        <img src="@/assets/facebook.svg">
                        <img src="@/assets/skype.svg">
                    </div>
                </div>
                <div v-else>
                    <div>Expected DOJ <br> {{doj}} <br/> {{dojLoc}}</div><br>
                    <div class="offer-status"> {{offerStatus}} </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmployeeDetailsCard',
    props: {
    'employed': {
      type: Boolean,
      default: false
    },
    'onboarding': {
      type: Boolean,
      default: false
    },
    empId: {
        type: String
    },
    empName: {
        type: String
    },
    empDetails: {
        type: String
    },
    empDept: {
        type: String
    },
    joiningStatus: {
        type: String
    },
    joiningTime: {
        type: String
    },
    empPhone: {
        type: String
    },
    empMail: {
        type: String
    },
    empAddress: {
        type: String
    },
    reportsTo: {
        type: String
    },
    doj: {
        type: String
    },
    dojLoc: {
        type: String
    },
    offerStatus: {
        type: String
    },
    empStatus: {
        type: String
    },
    width: 0,
    
  },
  data() {
      return {
          actionTypeVar: '',
          showActionMenu: false,
      }
  },
  methods: {
      dropdown() {
          this.showActionMenu = true;
      },
      edit() {
          this.showActionMenu = false;
          this.actionTypeVar = 'edited'
        //   //console.log('edited');
          this.$emit('actionType',this.actionTypeVar)
      },
      view() {
          this.showActionMenu = false;
          this.actionTypeVar = 'view'
        //   //console.log('view');
          this.$emit('actionType',this.actionTypeVar)
      },
      deleteEmp() {
          this.showActionMenu = false;
          //console.log('deleteEmp');
          this.actionTypeVar = 'deleteEmp'
          this.$emit('actionType',this.actionTypeVar)
      },
      assignManager() {
          this.showActionMenu = false;
          //console.log('assignManager');
          this.actionTypeVar = 'assignManager'
          this.$emit('actionType',this.actionTypeVar)
      },
      assignRole() {
          this.showActionMenu = false;
          //console.log('assignRole');
          this.actionTypeVar = 'assignRole'
          this.$emit('actionType',this.actionTypeVar)
      },
      holdSalary() {
          this.showActionMenu = false;
          //console.log('holdSalary');
          this.actionTypeVar = 'holdSalary'
          this.$emit('actionType',this.actionTypeVar)
      },
      
  }
}
</script>

<style lang="scss" scoped>
.card-container {
    width: 100%;
}
.employee {
    width: 32%;
    height: 210px;
    border-radius: 10px;
    border: solid 1px #f2f2f2;
    display: inline-flex;
    background-color: #ffffff;
    margin: 0px 10px 10px 0px;
}
.employee-img {
    position: relative;
    width: 51%;
    border-right: 1px solid #f2f2f2;
    // opacity: 0.11;
    padding: 10px;
    height: 100%;
}
.imgDetails {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .link-actions {
        margin-left: 10px;
        display: flex;
        justify-content: space-between;
    }
}
.action-container {
    right: 15px;
    position: absolute;
    display: flex;
    // flex-direction: column;
    img {
        cursor: pointer;
    }
}
.action {
   width: 4px;
   height: 4px;
   margin: 4px;
   color: #000000;
}
.employee-details {
    width: 60%;
    padding: 12px;
    position: relative;
}
.checkbox {
    position: absolute;
    height: 18px;
    width: 18px;
    border-radius: 4px;
    border: 1px solid #f2f2f2;
    background-color: #ffffff;
}
.empId {
    color: #878787;
    font-size: 12px;
    text-align: center;
}
.empName {
    font-family: Montserrat;
    font-size: 14px;
    color: #979797;
    margin-left: 13px;
}
.empDetails {
    font-family: Montserrat;
    font-size: 12px;
    color: #979797;
    text-align: center;
    // margin-left: 30px;
}
.details {
    font-family: Montserrat;
    font-size: 12px;
    color: #878787;
    img {
        width: 10px;
        height:10px;
        margin-right: 5px;
    }
}
.link-actions {
    display: flex;
    justify-content: space-around;
    cursor: pointer;
    img {
        width:13px;
        height:13px;
    }
}
button {
    margin-top: 10px;
    width: 75px;
    height: 20px;
    cursor: pointer;
    font-size: 12px;
    border-radius: 4px;
    color: #555555;
    border: 1px solid #37c6c0;
}
.joining-time {
    color: #5d409f;
    font-size: 12px;
    margin-top: 10px;
}
.offer-status {
    color: #5d409f;
    font-size: 12px;
    cursor: pointer;
}

.action-container-icon {
    margin-left: 98%;
}
.action-menu {
    width: 128px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.23);
    background-color: #ffffff;
    margin-right: 10px;
    border-right: 20px solid #ffffff;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;

    .edit  {
        cursor: pointer;
        // margin-left: 5px;
        font-size: 12px;
        padding: 5px 0px 5px 5px;
        color: #616363;
        width: 120px;
        // text-align: center;

        &:hover {
        border: 1px solid #c0edeb;
        // width: 120px;
        // height: 20px;
        // color:red;
        background-color: #c0edeb;
     }
    }
}
// .selected {
//      &.hover {
//         border: 1px solid #c0edeb;
//         width: 120px;
//         height: 40px;
//         background-color: #c0edeb;
//      }
// }
.action-menu:after {
     filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
    position: absolute;
    width: 0;
    top: 0px;
    right: 5%;
    height: 0;
    content: '';
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 10px solid #ffffff;
    filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
}

.progress-bar {
  margin-top: 20px;
  margin-bottom: 5px;
  width: 108px;
  height: 8px;
  border-radius: 4px;
  border: solid 1px #34c0be;
  background-color: #ffffff;
  position: relative;
}
.progress {
    position: absolute;
    background-color: #b2f8f7;
    width: 50%;
    border-radius: 4px;
    height: 6px;
}
.show-progress {
    padding: 7px;
    color: #5d409f;
    font-size: 12px;
}
</style>
